import { render, staticRenderFns } from "./PageBody.vue?vue&type=template&id=0646e2a6&scoped=true"
import script from "./PageBody.vue?vue&type=script&lang=js"
export * from "./PageBody.vue?vue&type=script&lang=js"
import style0 from "./PageBody.vue?vue&type=style&index=0&id=0646e2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646e2a6",
  null
  
)

export default component.exports